import { render, staticRenderFns } from "./DashboardGoogleAuthWarning.vue?vue&type=template&id=5529d7a4&scoped=true"
import script from "./DashboardGoogleAuthWarning.vue?vue&type=script&lang=js"
export * from "./DashboardGoogleAuthWarning.vue?vue&type=script&lang=js"
import style0 from "./DashboardGoogleAuthWarning.vue?vue&type=style&index=0&id=5529d7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529d7a4",
  null
  
)

export default component.exports